export const getRelativeTime = (dateInput: string | number | Date): string => {
        const date = new Date(dateInput);
        const now = new Date();
        const diff = (date.getTime() - now.getTime()) / 1000; // difference in seconds
        const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
        // console.log("time",rtf)

        const divisions: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
            { amount: 60, unit: "seconds" },
            { amount: 60, unit: "minutes" },
            { amount: 24, unit: "hours" },
            { amount: 7, unit: "days" },
            { amount: 4.34524, unit: "weeks" },
            { amount: 12, unit: "months" },
            { amount: Number.POSITIVE_INFINITY, unit: "years" },
        ];

        let duration = diff;
        for (const division of divisions) {
            if (Math.abs(duration) < division.amount) {
                return rtf.format(Math.round(duration), division.unit);
            }
            duration /= division.amount;
        }

        return "";
    }